import { connect } from 'react-redux';

import {
  editPaymentDetails,
  setEditPaymentDetailsMessage,
  setEditPaymentDetailsSuccess,
} from '../../actions/accountSettingsAction';
import { cancelScheduleIosStripeSwitch } from '../../actions/manageSubscriptionActions';
import { loadPlans } from '../../actions/signUpActions';
import {
  getCouponUserSelector,
  getEditPaymentDetailsMessage,
  getEditPaymentDetailsSuccess,
  getEditPaymentDetailsWaiting,
  getLoadingUserSubscription,
  getUserSubscription,
} from '../../components/AccountSettings/AccountSettingsSelectors';
import ManageSubscription from '../../components/AccountSettings/ManageSubscription/ManageSubscriptionView';
import { getPlans } from '../../components/SignUp/SignUpSelectors';
import { getUser } from '../../components/User/userSelectors';

const mapStateToProps = (state) => ({
  user: getUser(state),
  userSubscription: getUserSubscription(state),
  laodingUserSubscription: getLoadingUserSubscription(state),
  editPaymentDetailsWaiting: getEditPaymentDetailsWaiting(state),
  editPaymentDetailsSuccess: getEditPaymentDetailsSuccess(state),
  editPaymentDetailsMessage: getEditPaymentDetailsMessage(state),
  plans: getPlans(state),
  coupon: getCouponUserSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  editPaymentDetails: (subscriptionId, details) =>
    dispatch(editPaymentDetails(subscriptionId, details)),
  setEditPaymentDetailsMessage: (message) =>
    dispatch(setEditPaymentDetailsMessage(message)),
  setEditPaymentDetailsSuccess: (value) =>
    dispatch(setEditPaymentDetailsSuccess(value)),
  loadPlans: () => dispatch(loadPlans()),
  cancelScheduleIosStripeSwitch: () =>
    dispatch(cancelScheduleIosStripeSwitch()),
});

const ManageSubscriptionContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ManageSubscription);

export default ManageSubscriptionContainer;
